import { AxiosRequestConfig } from "axios";
import { AuthenticationHelper } from "@/apps/core-app-onboarding/helpers/authentication.helper";
import DatadogLogger from "@/shared-helpers/datadog-logger.helper";
import { LogType } from "@/types/dataDogLogType";

export const jsonHeader = (body: string | null): AxiosRequestConfig => {
  let Authorization: string;

  try {
    Authorization = AuthenticationHelper.getAuthHeader(body) || "";
  } catch (error: unknown) {
    DatadogLogger.Log(
      `Self Onboarding Error - Auth Header error`,
      error as Record<string, unknown>,
      LogType.ERROR
    );
    Authorization = "";
  }

  return {
    headers: {
      "Content-Type": "application/json",
      Authorization,
    },
  };
};
